<template>
    <div class="postDetails spackage padding-20 bgc box-shadow">
        <div class="issueContent">
            <!--上面操作-->
            <div class="postDet_wrap">
                <div class="title"><span>帖子详情</span></div>
                <div class="postDet_main">
                    <div class="postTop">
                        <span class="postTitle">发帖人信息：</span>
                        <div class="postInfo">
                            <img :src="detailsList.customerlogo" alt="logo">
                            <div>
                                <p style="margin-bottom: 10px">{{detailsList.customername}}</p>
                                <p>{{detailsList.datetime}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="postBottom">
                       <div v-if="detailsList.subject">
                           <span class="postTitle">帖子标题:</span>
                           <span>{{detailsList.subject}}</span>
                       </div>
                        <div style="margin-top: 20px">
                            <span class="postTitle">帖子详情:</span>
                            <span class="color">
                                <!-- 扫码查看帖子详情 -->
                                <el-popover placement="bottom" width="200" trigger="click">
                                    <img :src="popoverimg" alt="qrcode">
                                    <el-button class="color" style="border:none;background:rgba(0,0,0,0)" slot="reference" @click="scanning(detailsList.url)">点击扫码查看帖子详情</el-button>
                                </el-popover>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="articleForm form">
                <el-form  label-width="110px" class="demo-item" label-position="left" size="mini">
                    <el-form-item label="操作" prop="articlename">
                        <div class="position">
                            <span @click="delClick(detailsList.contentid)">删除</span>
                            <span @click="priseClick(detailsList.contentid)">马甲点赞</span>
                            <span @click="isgoodClick(detailsList.contentid, detailsList.isgood)">{{detailsList.isgood =='0'?'加精':'取消加精'}}</span>
                            <span @click="istopClick(detailsList.contentid, detailsList.istop)">{{detailsList.istop =='0'?'置顶':'取消置顶'}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="回复">
                        <el-input type="textarea" v-model="form.content" placeholder="输入帖子回复，不超过100个字" clearable maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="选择马甲">
                        <el-select v-model="form.sockid">
                            <el-option v-for="item in mlist" :key="item.innerid" :value="item.innerid" :label="item.name"></el-option>
                        </el-select>
                        <el-button type="primary" align="left" style="float: right" @click="submitPl(detailsList.contentid)">评论</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="pl">
                <div class="title"><span>用户评论</span></div>
                <div class="pl-list">

                    <div class="pl-item" v-for="item in plDataList">
                        <img :src="item.comheadimageurl" alt="logo">
                        <div class="pl-content">
                            <p class="pl-title">
                                <span>{{item.comcustomername}}</span>
                                <span>{{item.comdatetime}}</span>
                            </p>
                            <p class="pl-text">{{item.comcontent}}</p>
                        </div>
                        <el-dropdown>
                                  <span class="el-dropdown-link">
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                  </span>
                            <el-dropdown-menu style="width: 100px" slot="dropdown">
                                <el-dropdown-item @click.native="hfClick(item.cominnerid, item.comcustomername)">回复</el-dropdown-item>
                                <el-dropdown-item @click.native="delPl(item.cominnerid)">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>


                        <div class="pl-item" v-for="reitem in item.replyDatainfo">
                            <img :src="reitem.replyHeadimageurl" alt="logo">
                            <div class="pl-content">
                                <p class="pl-title">
                                    <span>{{ reitem.replyCustomername }}</span>回复<span>{{item.comcustomername}}</span>
                                </p>
                                <p class="pl-text">{{ reitem.replyContent }}</p>
                            </div>
                            <!--<el-dropdown>-->
                                        <!--<span class="el-dropdown-link">-->
                                            <!--<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                                        <!--</span>-->
                                <!--<el-dropdown-menu style="width: 100px" slot="dropdown">-->
                                    <!--<el-dropdown-item @click.native="hfClick('innerid')">回复</el-dropdown-item>-->
                                    <!--<el-dropdown-item @click.native="delClick('innerid')">删除</el-dropdown-item>-->
                                <!--</el-dropdown-menu>-->
                            <!--</el-dropdown>-->
                        </div>
                    </div>
                </div>
            </div>

            <div class="more">
                <p style="cursor: pointer" v-if="pageinfo.pageCount > pllistData.page" @click="clickpage">点击加载更多 <i class="el-icon-d-arrow-right"></i></p>
                <p v-if="pageloading == true">加载中...</p>
                <template v-if="pageinfo.pageCount > 1 && pageloading == false">
                    <p v-if="pageinfo.pageCount === pllistData.page || pageinfo.pageCount < pllistData.page">没有更多了</p>
                </template>
            </div>
        </div>

        <el-dialog
            title="回复"
            :visible.sync="dialogVisible"
            width="600px"
            :before-close="handleClose">

            <el-input type="textarea" style="width: 500px" v-model="plDialogData.content" :placeholder="'回复  '+dialogVisibleData.name+' 的评论，不超过100个字'" clearable maxlength="100" show-word-limit></el-input>

            <div style="margin-top: 20px">
                <span>请选择马甲：</span>
                <el-select v-model="plDialogData.sockid">
                    <el-option v-for="item in mlist" :key="item.innerid" :value="item.innerid" :label="item.name"></el-option>
                </el-select>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="submitdialog">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
    import {deleteCwKmcStarcommentinfo, saveCwKmcStarcommentreplyinfo, getCwKmcStarcommentreplyinfo, getCwKmcStarfiledetail, findAllStarsockpuppet, postIstop, postIsgood, postDel, vestPraise, saveCwKmcStarcommentinfo } from 'api/communityApi'
    import {mapGetters,mapActions} from 'vuex'
    import {urlToQRCode} from 'common/js/tools'
    export default {
        name: "StartPostPostDetails",
        data(){
            return{
                starinnerid: this.$route.query.innerid, // 星球id
                sourceinnerid: this.$route.query.starid, // 帖子id
                mlist: [],
                form:{
                    content: '',
                    sockid: ''
                },
                popoverimg: '',
                dialogVisible: false,
                dialogVisibleData: {},
                pllistData: {
                    page: 1
                },
                detailsList: {},
                plDataList: [],
                plDialogData: {
                    sockid: '',
                    content: ''
                },
                pageinfo: {},    // 页数
                pageloading: false // 点击加载
            }
        },
        mounted() {
           // 帖子详情
           this.tzDetails((data)=> {
               // 评论回复信息
               this.pllist(1)
           })
            // 马甲列表
            this.findAllStarsockpuppetList()
        },
        methods: {
            handleClose() {
                this.plDialogData = {
                    sockid: '',
                    content: ''
                }
                this.dialogVisibleData = {}
                this.dialogVisible = false
            },
            scanning(url) {
                // 扫码
                this.popoverimg = urlToQRCode(url)
            },
            findAllStarsockpuppetList() {
                this.setLoading(true)
                let data = {
                    starinnerid: this.starinnerid
                }
                findAllStarsockpuppet({
                    data: data,
                    success: data => {
                        this.setLoading(false)
                        this.mlist = data.data
                        this.mlist.unshift({innerid:'',name:'不使用马甲'})
                        // console.log('findAllStarsockpuppet',data)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            clickpage() {

                this.pllistData.page += 1
                this.pageloading = true

                this.setLoading(true)
                getCwKmcStarcommentreplyinfo({
                    data: this.pllistData,
                    success: data => {
                        this.setLoading(false)
                        this.pageloading = false
                        this.$nextTick(()=> {
                            this.plDataList = this.plDataList.concat(data.data.content)
                        })
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })

            },
            pllist(page) {
                let datatype  = 3   // 3帖子 2详情
                // 用户评论回复信息列表
                this.pllistData = {
                    innerid: this.sourceinnerid,
                    datatype: datatype,    // 帖子
                    // contentinnerid: this.detailsList.contentid,
                    page: page,
                    pageSize: 10
                }
                this.setLoading(true)
                getCwKmcStarcommentreplyinfo({
                    data: this.pllistData,
                    success: data => {
                        this.setLoading(false)
                        this.$nextTick(()=> {
                            this.plDataList = data.data.content
                            this.pageinfo = data.data.pageinfo
                            // console.log('getCwKmcStarcommentreplyinfo',data)
                        })
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })

            },
            tzDetails(request) {
                // 帖子详情
                let data = {
                    innerid: this.sourceinnerid,
                    starid: this.starinnerid,
                    datatype: 3

                }
                this.setLoading(true)
                getCwKmcStarfiledetail({
                    data: data,
                    success: data => {
                        console.log(data)
                        this.setLoading(false)
                        this.detailsList = data.data

                        if (request) {
                            request(data)
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 置顶
            istopClick(id,type){
                let params = {
                    innerid: id,
                    istop: type == '0' ? '1' : '0',
                };
                this.setLoading(true);
                postIstop({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.tzDetails();
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        });
                    },
                    error: data => {
                        this.setLoading(false);
                        console.log('error：', data)
                    }
                })
            },
            //加精
            isgoodClick(id,type){
                let params = {
                    innerid: id,
                    isgood: type == '0' ? '1' : '0',
                };
                this.setLoading(true);
                postIsgood({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.tzDetails();
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        });
                    },
                    error: data => {
                        this.setLoading(false);
                        console.log('error：', data)
                    }
                })
            },
            // 删除帖子
            delClick(id) {
                this.$confirm('删除后将不可恢复，确认删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    let params = {
                        innerid: id,
                        status: 100
                    };
                    this.setLoading(true);
                    postDel({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            // this.tzDetails();
                            this.$message.success(`删除成功!`)
                            this.$router.back()
                        },
                        error: data => {
                            this.setLoading(false);
                            console.log('error：', data)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            // 删除评论
            delPl(id) {
                this.$confirm('删除后将不可恢复，确认删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    let params = {
                        innerid: id
                    };
                    this.setLoading(true);
                    deleteCwKmcStarcommentinfo({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            this._huifulist()
                            this.$message.success(`删除成功!`)
                        },
                        error: data => {
                            this.setLoading(false);
                            console.log('error：', data)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            // 马甲点赞
            priseClick(id) {
                let params = {
                    innerid: id,
                    datatype: 3
                };
                this.setLoading(true);
                vestPraise({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.tzDetails();
                        this.$message({
                            message: '点赞成功',
                            type: 'success'
                        });
                    },
                    error: data => {
                        this.setLoading(false);
                        console.log('error：', data)
                    }
                })
            },
            // 回复
            hfClick(id,name) {
                this.dialogVisible = true
                this.dialogVisibleData = {
                    innerid: id,
                    name: name
                }

            },
            // 提交回复
            submitdialog() {
                let data = JSON.parse(JSON.stringify(this.plDialogData))
                data.commentid = this.dialogVisibleData.innerid
                // data.starid = this.starinnerid
                // data.datatype = 3
                this.setLoading(true)
                saveCwKmcStarcommentreplyinfo({
                    data: data,
                    success:data => {
                        console.log('saveCwKmcStarcommentreplyinfo',data)
                        this.$message.success('回复成功')
                        this.setLoading(false)
                        this.dialogVisible = false

                        this._huifulist()

                    //    replyDatainfo
                    },
                    error:data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            },
            // 删除回复回调
            _huifulist(){
                // 回复列表
                let datatype  = 3,   // 3帖子 2详情
                    dataapi = JSON.parse(JSON.stringify(this.pllistData))
                dataapi.pageSize = this.pllistData.page * this.pllistData.pageSize
                dataapi.page = 1

                // 用户评论回复信息列表
                this.setLoading(true)
                getCwKmcStarcommentreplyinfo({
                    data: dataapi,
                    success: data => {
                        this.setLoading(false)
                        this.$nextTick(()=> {
                            this.plDataList = data.data.content
                            // console.log('getCwKmcStarcommentreplyinfo',data)
                        })
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 提交评论
            submitPl(id) {
                let data = JSON.parse(JSON.stringify(this.form))
                data.innerid = id
                data.starid = this.starinnerid
                data.datatype = 3

                this.saveCwKmcStarcommentinfo(data,(data) => {

                    this.$message.success('回复成功')
                    this.$nextTick(() => {
                        this.form.content = ''
                    })
                    // 回复成功，调用回复列表接口
                    this.pllist(1)
                    console.log(data)
                })
            },
            saveCwKmcStarcommentinfo(api, request) {
                this.setLoading(true)
                saveCwKmcStarcommentinfo({
                    data: api,
                    success: data => {
                        this.setLoading(false)
                        request(data)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            },
            ...mapActions([
                'setLoading'
            ])

        }
    }
</script>

<style  lang="scss" type="text/scss">
    .postDetails {
        .el-dropdown {
            position: absolute;
            right: 0;
            top: 20px;
            width: 30px;
            height: 10px;
            line-height: 10px;
            .el-dropdown-menu {
                width: 100px;
            }
            .el-dropdown-link {
                cursor: pointer;
                color: #409EFF;
            }
        }
        .title {
            padding-left: 8px;
            border-left: solid 2px #409EFF;
             span {
                 font-size:16px;
                 font-weight: bold;
                 color: #303133;
             }
        }
        .el-textarea__inner {
            width: 730px;
        }
        .postDet_wrap .title{
            color: #409EFF;
            font-size: 16px;
            margin-bottom: 20px;
            span{
                color: #303133;
                font-weight: 700;
                position: relative;
                top: 2px;
            }
        }

        .issueContent {
            width: 840px;
        }
        .postDet_main{
            width: 800px;
            height: auto;
            padding: 20px;
            background:rgba(245,247,250,1);
            .postTitle{
                width: 100px;
                display: inline-block;
                color: #303133;
            }
            .postTop{
                padding-bottom: 20px;
                border-bottom: 1px solid #DCDFE6;
                .postInfo{
                    display: flex;
                    align-items: center;
                    img{
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                        background: #eee;
                        display: inline-block;
                        margin-right: 10px;
                    }
                }
            }
            .postBottom {
                display: block !important;
                padding-top: 20px;
            }
            .color {
                color: #409eff;
            }
        }
        .postDet_main>div{
            display: flex;
            align-items: center;
        }
        .position {
            span {
                color: #409eff;
                margin-right: 10px;
                cursor: pointer;
            }
        }
        .pl {
            margin-top: 38px;
            width: 840px;


            .pl-item {
                display: block;
                position: relative;
                width: 100%;
                padding: 20px 0;
                flex-wrap: nowrap;
                align-content: flex-start;
                border-bottom: solid 1px #DCDFE6;
                overflow: hidden;

                img {
                    float: left;
                    margin-right: 8px;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background: #ccc;
                }
                .pl-content {
                    float: left;
                    max-width: 630px;
                    .pl-title {
                        span {
                            display: inline-block;
                            margin-right: 20px;
                        }
                        span:last-child {
                            font-size: 14px;
                            color: #C0C4CC;
                        }
                        span:first-child {
                            font-size: 16px;
                            color: #303133;
                        }
                    }
                    .pl-text {
                        margin-top: 10px;
                        font-size: 14px;
                        color: #909399;
                        line-height: 20px;
                    }
                }

                .pl-item {
                    padding-left: 60px;
                    box-sizing: border-box;
                    .el-dropdown {
                        line-height: 30px;
                    }
                    img {
                        width: 30px;
                        height: 30px;
                    }

                    .pl-title {
                        line-height: 30px;
                        span {
                            padding: 0;
                            margin: 0 10px;
                            font-size: 16px !important;
                            color: #409EFF !important;
                        }
                    }

                }
                .pl-item:last-child {
                    border: none;
                }

            }
        }
        .more {
            margin-top: 15px;
            width: 840px;
            text-align: center;
            span {
                font-size: 13px;
                color: #606266;
            }
            i {
                -webkit-transform: rotate(90deg);
                -moz-transform: rotate(90deg);
                -ms-transform: rotate(90deg);
                -o-transform: rotate(90deg);
                transform: rotate(90deg);
            }
        }
        .el-dialog {
            .el-textarea__inner {
                width: 560px !important;
            }
            .el-button {
                margin-bottom: 10px
            }
        }

    }

</style>
